import { getDefaultVersion } from 'components/VersionComponent';
import { analytics } from 'config/ApiService';
import { logEvent } from 'firebase/analytics';
import store from 'redux/store/store';

/**
 * Retrieves metadata about the logged-in user and organisation.
 * by extracting details from the Redux store.
 * @returns {object}
 */
const metadata = (): { [key: string]: any } => {
    const { user, organisation, currentRegion } = store.getState().AuthReducer;
    const appVersion = getDefaultVersion();
    return {
        logged_in_user_id: user?.id,
        logged_in_user_role: user?.role,
        logged_in_username: `${user.first_name} ${user.last_name}`,
        region: currentRegion,
        customer_id: organisation?.id,
        customer_name: organisation?.name,
        portal_version: appVersion
    };
};

export const logScreenView = (screenName: string, eventParams?: { [key: string]: any }) => {
    logEvent(analytics, 'page_view', {
        page_title: screenName,
        ...eventParams,
        ...metadata()
    });
};

export const logGoogleAnalyticsEvent = (
    eventName: string,
    eventParams?: { [key: string]: any }
) => {
    logEvent(analytics, eventName, {
        ...eventParams,
        ...metadata()
    });
};
